import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

import { useState } from "react"
import BwipJs from "@bwip-js/browser"
import FooterImage from './footer-image'

const barcodeWidths = {
  PKBarcodeFormatAztec: 156,
  PKBarcodeFormatQR: 156,
  PKBarcodeFormatPDF417: 250,
  PKBarcodeFormatCode128: 250,
  undefined: 150
}

const barcodeHeigths = {
  PKBarcodeFormatAztec: 144,
  PKBarcodeFormatQR: 144,
  PKBarcodeFormatPDF417: 60,
  PKBarcodeFormatCode128: 60,
  undefined: 140
}


const options = {
  AZTEC: {
    bcid: 'azteccode',
    scale: 1,
    includetext: false,
    eclevel: 23,
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
    padding: 8,
    paddingbottom: 1,
  },
  QR_CODE: {
    bcid: 'qrcode',
    scale: 1,
    includetext: false,
    eclevel: "M",
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
    padding: 8,
    paddingbottom: 1,
  },

  PDF_417: {
    bcid: 'pdf417',
    scale: 1,
    includetext: false,
    width: 80,
    height: 20,
    padding: 5,
    paddingbottom: 1,
  },
  CODE_128: {
    bcid: 'code128',
    scale: 1,
    width: 80,
    height: 20,
    includetext: false,
    padding: 5,
    paddingbottom: 1,
  }
}

const Barcode = () => {

  const { template, variables } = useContext(PassContext)
  const barcodeData = dataSelector({ template, variables, path: "barcode" })

  try {
    let [img, setImg] = useState(null)
    let [barcodeMessage, setBarcodeMessage] = useState(null)
    let [barcodeFormat, setBarcodeFormat] = useState(null)

    if (barcodeData && barcodeData.message?.length && barcodeData.format !== "NONE") {
      if (!img || barcodeMessage !== barcodeData.message || barcodeFormat !== barcodeData.format) {
        let canvas = document.createElement('canvas')

        const barcodeOptions = options[barcodeData?.format]

        if (barcodeOptions) {
          BwipJs.toCanvas(canvas, { ...barcodeOptions, text: barcodeData?.message ?? "dummy barcode value" })

          let barcode = canvas.toDataURL('image/png')

          setImg(barcode)
          setBarcodeFormat(barcodeData?.format)
          setBarcodeMessage(barcodeData?.message)
        }
      }
    } else {
      if (img) {
        setImg(null)
        setBarcodeFormat(null)
        setBarcodeMessage(null)
      }
    }

    return (
      <div className="barcode-wrapper">
        {/* Footer needs to be absolutely positioned just above the barcode. Hence included here. */}
        <FooterImage />

        <div className="flex flex-row w-full justify-center" >
          <PopupEditor title="Barcode" path="barcode">
            <div className="editable" style={{ minWidth: 150, minHeight: 150, padding: 10, marginTop: 0, marginBottom: 10 }}>
              {barcodeData && barcodeData.format !== "NONE" &&
                <div className="barcode-background">
                  <img src={img} style={{ width: barcodeWidths[barcodeData?.format], height: barcodeHeigths[barcodeData?.format], margin: "auto" }} />
                  <div className="text" style={{ minHeight: 30 }}>{barcodeData?.altText ?? '000-000-000'}</div>
                </div>
              }
            </div>
          </PopupEditor>
        </div>
      </div>
    )
  }

  catch (err) {
    throw err
  }
}

export default Barcode